import { render } from "./Studio15TalentList.vue?vue&type=template&id=62769001&scoped=true&ts=true&lang=pug"
import script from "./Studio15TalentList.vue?vue&type=script&lang=ts"
export * from "./Studio15TalentList.vue?vue&type=script&lang=ts"

import "./Studio15TalentList.vue?vue&type=style&index=0&id=62769001&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62769001"]])

export default __exports__